// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"../../colors.css\"","primary-color":"#027aff","text-color-1":"#333333","text-color-2":"#333333","table-header-bg-color":"#f4f8fb","disease":"drugWarning_disease__3cilT"};